import { motion } from "framer-motion";
import { Check, Clock } from "lucide-react";
import { SERVICES } from "../../lib/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 } }),
};

const spans = ["md:col-span-8", "md:col-span-4", "md:col-span-4", "md:col-span-4", "md:col-span-4"];

export const Services = ({ onBook }) => {
  return (
    <section id="services" className="relative py-24 md:py-36 max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#C9A24B] mb-4">The Menu</p>
          <h2 className="font-serif-display text-4xl md:text-6xl font-light tracking-tight text-[#FAFAFA]">
            Services, <span className="italic gold-gradient-text">refined</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm text-[#8A8A8A] font-light">
          Haircuts are live today. Braids, coloring, dreadlocks and accessories are rolling out soon.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => {
          const available = s.status === "available";
          const isShop = s.status === "shop";
          const active = available || isShop;
          const goShop = () => document.querySelector("#shop")?.scrollIntoView({ behavior: "smooth" });
          return (
            <motion.div
              key={s.id}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className={`${spans[i]} group relative overflow-hidden rounded-sm border ${active ? "border-[#C9A24B]/40" : "border-white/10"} bg-[#141414] min-h-[300px]`}
              data-testid={`service-card-${s.id}`}
            >
              <img
                src={s.image}
                alt={s.name}
                className={`absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05] ${active ? "opacity-45" : "opacity-20 grayscale"}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />

              <div className="relative z-10 h-full flex flex-col justify-between p-8">
                <div className="flex items-center justify-between">
                  <span className={`inline-flex items-center gap-2 px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] rounded-sm ${active ? "bg-[#C9A24B] text-black" : "bg-white/5 text-[#8A8A8A] border border-white/10"}`}>
                    {active ? <Check size={12} /> : <Clock size={12} />}
                    {available ? "Available Now" : isShop ? "Shop Open" : "Coming Soon"}
                  </span>
                  {s.price && <span className="text-xs text-[#C9A24B] tracking-wide">{s.price}</span>}
                </div>

                <div>
                  <h3 className={`font-serif-display text-3xl md:text-4xl tracking-tight mb-3 ${active ? "text-[#FAFAFA]" : "text-[#8A8A8A]"}`}>
                    {s.name}
                  </h3>
                  <p className="text-sm text-[#8A8A8A] font-light max-w-md leading-relaxed">{s.blurb}</p>
                  {available && (
                    <button
                      onClick={onBook}
                      data-testid={`service-book-${s.id}`}
                      className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#C9A24B] hover:gap-3 transition-all duration-300"
                    >
                      Book this <span>→</span>
                    </button>
                  )}
                  {isShop && (
                    <button
                      onClick={goShop}
                      data-testid={`service-shop-${s.id}`}
                      className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#C9A24B] hover:gap-3 transition-all duration-300"
                    >
                      Shop now <span>→</span>
                    </button>
                  )}
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
